<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div :class="checkWidth() + ' CIT_background'">
        <div
          class="position"
          v-bind:style="[
            !flipped ? {'padding-bottom': '5%'} : {'padding-bottom': '13%'},
          ]"
        >
          <div style="margin-left: auto; margin-right: auto">
            <h1>QUIZ TIME !</h1>
          </div>
          <div class="card">
            <div class="block">
              <div class="flashcard-list">
                <transition name="flip">
                  <!-- Card Start -->
                  <template v-if="!flipped">
                    <img
                      style="width: 100%; height: 100%"
                      :src="'https://mdl.mfu.ac.th/' + content.media[0].url"
                    />
                  </template>

                  <!-- Card Question -->
                  <template v-if="flipped">
                    <div class="card_question">
                      <div class="block_question">
                        <CRow>
                          <CCol col="12">
                            <div class="font_setting">
                              <p style="font-size: 2rem; margin-bottom: 0">
                                <b>{{ checkLanguage(content.title) }}</b>
                              </p>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                      <div
                        class="choice"
                        v-for="(item, index) in sort_data"
                        :key="index"
                      >
                        <CRow
                          class="container_CIT01 component_select"
                          v-bind:style="
                            ans == index
                              ? styleTrue
                              : index_select == index
                              ? styleObject
                              : ''
                          "
                          @click="select_question(index)"
                        >
                          <div style="padding: 2%">
                            <div style="font-size: 20px; text-align: center">
                              {{ item.question }}
                            </div>
                          </div>
                        </CRow>
                      </div>
                    </div>
                  </template>
                </transition>
              </div>
            </div>
          </div>
          <!-- container -->

          <CRow
            style="
              display: flex;
              justify-content: center;
              margin-left: auto;
              margin-right: auto;
            "
            v-if="!flipped"
          >
            <div class="button button_setting" @click="toggleCard()">
              <CCol col="8">
                <div style="font-size: 18px">START</div>
              </CCol>
              <CCol col="2">
                <i class="fas fa-caret-right fa-3x" style=""></i>
              </CCol>
            </div>
          </CRow>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Button from '../../../components/signInCss/Button.vue';
import LoadingMDL from '@/components/loading/LoadingMDL';
import TEMPLATE from '../../../TEMPLATE.vue';

export default {
  components: {Button, LoadingMDL, TEMPLATE},
  name: 'QZ06',
  props: {},
  data() {
    return {
      flipped: false,
      styleTrue: {},
      language: 'en',
      loading: true,
      content: [],
      sort_data: [],
      ans: null,
      styleObject: {},
      index_select: null,
      navigation: {},
      startTime: '',
      condition: [],
      criteria_id: '',
      topic: {},
      chapter: null,
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      randomNumber: null,
      index: null,
      v3Data: null,
      v3Score: 0,
      nextPath: null,
    };
  },
  methods: {
    toggleCard: function () {
      this.flipped = !this.flipped;
    },
    select_question: function (val) {
      // console.log(val, 'value');

      this.styleTrue = {
        backgroundColor: 'green',
        color: 'white',
      };
      this.index_select = val;

      if (this.index_select == this.ans) {
        // console.log('Your answer Correct!');

        this.v3Score = 1; // ได้รับคะแนน
        this.styleObject = {
          'background-color': 'green',
          color: 'white',
        };
        setTimeout(() => {
          this.commitUserProgress();
        }, 1000);
      } else {
        // console.log('Your answer false');
        this.styleObject = {
          'background-color': 'red',
          color: 'white',
        };
        setTimeout(() => {
          this.commitUserProgress();
        }, 1000);
      }
    },
    commitUserProgress: function () {
      const path = this.navigate.next.action;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        score: this.v3Score,
        maxScore: 1,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
  },
  computed: {
    ...mapGetters({
      getTestTemplate: 'template/getTestTemplate',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.startTime = this.$helpers.getDateFormat();

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.image;
      this.navigate = template.navigate;

      //length data
      const length_data = template.content.item.length;
      this.randomNumber = Math.floor(Math.random() * length_data);

      this.index = template.content.item[this.randomNumber].order;
      const choices = template.content.item[this.randomNumber].choices;

      //loop choice
      if (choices.length > 0) {
        choices.forEach((element, index) => {
          if (element.answer == 'TRUE') {
            this.ans = index;
          }
        });
      }
      // console.log(choices, 'choices');

      //sort data
      this.sort_data = choices.sort(function (a, b) {
        return a.order.localeCompare(b.order);
      });

      if (this.sort_data.length !== 0) {
        this.content = template.content.item[this.randomNumber];
        this.loading = false;
      }

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'QZ06 saveContent Call');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    this.currentRoute = this.$route.name + '-' + this.$route.params.id;
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
  },
  mounted() {
    this.language = this.$store.getters['language/getLanguage'];

    this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.flip-enter-active {
  transition: all 0.4s ease;
}

.flip-leave-active {
  display: none;
}

.CIT_background {
  background-color: #ffdc77;
}

.flip-enter,
.flip-leave {
  transform: rotateY(180deg);
  opacity: 0;
}

.position {
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 8%;
}

.block {
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 5px;
}

.card {
  width: 450px;
  height: 450px;
  background-color: white !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
  /* 5px rounded corners */
  border: 0px solid;
  position: relative;
}

.card_question {
  background-color: white;
  width: 470px;
  height: 470px;
  max-height: 450px;
  margin-top: 12%;
  margin-bottom: 12%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 30px;
  /* 5px rounded corners */
  border: 0px solid;
}

.block_question {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ed8e91;
  width: 100%;
  height: 30%;
  border-radius: 30px 30px 0px 0px;
}

.container_CIT01 {
  width: auto;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 4%;
}

.component_select {
  width: 80%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #e6efff;
  color: #1d5bd7;
  font-size: 12px;
  border-radius: 40px !important;
  cursor: pointer;
}

.choice {
  // margin-bottom: 4%;
  margin-top: 3.5%;
  display: flex;
}

.font_setting {
  padding: 15px;
  color: white;
}

.button_setting {
  background-color: #f1b205;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 50%;
}

@media only screen and (max-width: 600px) {
  .card {
    width: 300px;
    height: 300px;
  }

  .card_question {
    width: 300px;
    height: 320px;
  }

  .position {
    padding-top: 20%;
  }
}

@media only screen and (max-width: 375px) {
  .choice {
    margin-top: 5%;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .position {
    padding-top: 10%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}
</style>
